<template>
  <div>
    <div style="width: 150px;display: inline-block"></div>
    <template v-if="pattern == 'model'">
      ※
      <Input :autosize="{minRows:3,maxRows:8}" style="display: inline-block;width: 350px;vertical-align: top" placeholder="此处填写说明文字！" type="textarea" v-model="content.text"></Input>
      <Icon class="close-icon" type="md-close-circle" @click="$emit('del',index)"></Icon>
    </template>
    <template v-else>
      <div style="display: inline-block">※{{content.text}}</div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "approvalExplain",
    props:{
      index:Number,
      pattern:String,
      contentIn:Object,
    },
    data:function () {
      return{
        content:{
          text:'',
        },
      }
    },
    mounted:function(){
      if(this.contentIn.text!=undefined){
        this.content = this.contentIn
      }
    },
    watch:{
      content:{
        handler(){
          this.$emit('change',this.content)
        },
        immediate:true,
      },
    }
  }
</script>

<style scoped>

</style>